import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import DisclaimerDialog from './DisclaimerDialog';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
const ProtectedRoute = () => {
  //const { logout } = useContext(AuthContext);
  const currentLocation = useLocation(); // ✅ safer name
  const {
    isAuthenticated,
    profileUpdated,
    disclaimerAccepted,
    loading,
    setDisclaimerAccepted,
    isLoggingOut, 
    logout,
    setIsLoggingOut
  } = useContext(AuthContext);

  const handleAgree = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/disclaimer/accept`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setDisclaimerAccepted(true);
    } catch (error) {
      console.error('Error accepting disclaimer:', error);
    }
  };

  const handleLogout = () => {
    // localStorage.removeItem('token');
    // window.location.href = "/login";
    logout();
    window.location.href = "/";
  };

  //if (loading || isAuthenticated === null || disclaimerAccepted === null) return null;
 
  //if (isLoggingOut) return <Navigate to="/" />;
  if (!isAuthenticated && !isLoggingOut) {
    return <Navigate to="/login" replace state={{ from: currentLocation }} />;
  }
  //if (!isAuthenticated) return <Navigate to="/login" />;
  //if (!isAuthenticated) return <Navigate to="/login" />;
  if (!disclaimerAccepted) {
    return <DisclaimerDialog open={true} onAgree={handleAgree} onLogout={handleLogout} />;
  }

  if (!profileUpdated && currentLocation.pathname !== '/profile-update') {
    return <Navigate to="/profile-update" />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
